import moment from 'moment';
import {format as dateTimeFormat, parse, isValid} from 'date-fns';
import {dateFormats, timeFormats} from '../locales/en';
import {subunitsToCurrencyWithSymbol} from './CurrencyFormat';

const isScalarTime = value => value > 0 && value < 2359;

const checkFormat = (formats, desiredFormat) =>
  Object.values(formats).some(x => x === desiredFormat);
const isTimeFormat = format => checkFormat(timeFormats, format);
const isDateFormat = format => checkFormat(dateFormats, format);

const formatTime = (value, format) => {
  const dateTime = new Date(0, 0, 0, value / 100, value % 100);
  return dateTimeFormat(dateTime, format);
};

const formatDate = (value, format) => dateTimeFormat(parse(value), format);
const isValidDate = value => isValid(parse(value));

const i18nFormat = (value, format) => {
  if (!format) return value;

  if (value instanceof moment) {
    return value.format(format);
  }

  if (isTimeFormat(format) && isScalarTime(value)) {
    return formatTime(value, format);
  }

  if (isDateFormat(format) && isValidDate(value)) {
    return formatDate(value, format);
  }

  if (format === 'currency') {
    const currency = value?.currency ?? 'USD';
    const subunits = value?.subunits ?? 0;
    return subunitsToCurrencyWithSymbol({subunits, currency});
  }

  return value;
};

export default i18nFormat;
